import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

import { SettingsLayout } from '@/components/layouts/settings-layout'
import { RadioButton } from '@/components/atoms/radio-button'
import { PrinterTab } from '@/components/molecules/settings/printer-tab'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { AccountContext } from '@/contexts/account'
import { usePrinterSetting } from '@/hooks/self-checkin-device-settings/use-printer-setting'

export const SettingPrinterSelfCheckin: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useContext<any>(AccountContext)
  const hotelId: string = account?.hotel?.id || account?.employee?.hotelId || ''
  const { isLoading, printerSettings, selectedId, selectPrinter } = usePrinterSetting(hotelId)

  return (
    <SettingsLayout loading={isLoading}>
      <TabContainer tabComponent={<PrinterTab currentTab="Self check-in" />}>
        <div css={headerContainerStyle}>
          {t('Please make selections on the tablet (iPad) to be used to connect the printer.')}
          <br />
          {t('When using multiple tablets/printers, please set up each tablet individually.')}
        </div>
        <div css={infoHeaderContainerStyle}>
          <div>{t('Printer name')}</div>
        </div>
        <div css={mainContainerStyle}>
          {printerSettings.map(device => (
            <div key={device.id || 'empty'} css={printerRowStyle}>
              <RadioButton
                id={device.id || 'empty'}
                checked={selectedId === device.id}
                item={{ value: device.id, label: device.deviceName }}
                onChange={() => selectPrinter(device)}
                style={{ radioSize: 20, labelMargin: 39 }}
                itemCss={printerRadioStyle}
              />
              {device.deviceHost && (
                <a target="_blank" rel="noreferrer" href={`https://${device.deviceHost}`} css={webConfigLinkStyle}>
                  web configを開く
                </a>
              )}
            </div>
          ))}
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const headerContainerStyle = css({
  height: 70,
  padding: '0 32px',
  borderBottom: '1px solid #F2F2F2',
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
  lineHeight: '17px',
  color: '#272727',
  letterSpacing: 0.56,
})

const infoHeaderContainerStyle = css({
  boxSizing: 'border-box',
  height: 32,
  padding: '0 78px',
  borderBottom: '1px solid #F2F2F2',
  background: '#F5F5F5',
  display: 'flex',
  alignItems: 'center',
  color: '#676767',
  fontSize: 12,
  fontWeight: 'bold',
})

const mainContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  color: '#272727',
  width: '100%',
  flexWrap: 'wrap',
})

const printerRowStyle = css({
  height: 64,
  borderBottom: '1px solid #F2F2F2',
  padding: '0 32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

const printerRadioStyle = css({
  flexGrow: 1,
  height: 64,
  '> label': {
    fontSize: 14,
    fontWeight: 'bold',
    letterSpacing: '1.4px',
  },
})

const webConfigLinkStyle = css({ color: '#f2a40b' })
